export default __webpack_public_path__ + "static/single-step-dark-8c6018d38b7ef4999eb922da67f9eda6.png";